var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadbandpostpaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.744,
    height: 39.654,
    viewBox: "0 0 50.744 39.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#4f4f4f;stroke-linecap:round;}.b{stroke:#40b895;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.869)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.417,219.391H70.908a1.623,1.623,0,0,1-1.618-1.618V201.529a1.623,1.623,0,0,1,1.618-1.618h45.507a1.623,1.623,0,0,1,1.618,1.618v16.244A1.621,1.621,0,0,1,116.417,219.391Z",
    transform: "translate(-69.29 -184.678)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 11.02,
    transform: "translate(37.863 4.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.757,97.029A5.95,5.95,0,0,1,307.2,86.97",
    transform: "translate(-272.513 -86.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M374.821,97.029a5.95,5.95,0,0,0-.441-10.059",
    transform: "translate(-333.232 -86.97)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 23.151,
    transform: "translate(6.205 21.376)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 8.042,
    transform: "translate(36.108 21.376)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 2.843,
    transform: "translate(9.538 35.942)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 2.843,
    transform: "translate(39.67 35.942)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandpostpaid);
export default __webpack_public_path__ + "static/media/broadbandpostpaid.5b495df08c7db50c5f01ef7340705089.svg";
export { ForwardRef as ReactComponent };